import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'semantic-ui-react'
import { css } from 'aphrodite'
import { Text } from './Text'
import { Image } from './Image'
import createStyles from './styles'

export class RadioField extends React.PureComponent {
  render() {
    const { meta, input, label, hint, disable = [], ...props } = this.props
    const styles = getStyles(props, this.context)

    return (
      <Form.Field
        error={!!(meta.touched && meta.error)}
        className={css(styles.root)}
      >
        {label && <label className={css(styles.label)}>{label}</label>}

        <div className={css(styles.options)}>
          {props.options.map((option, i) => (
            <div className={css(styles.option)} key={i}>
              {option.image && (
                <div
                  className={css(
                    styles.image,
                    option.value === input.value && styles.imageSelected,
                    disable.includes(option.value) && styles.imageDisabled
                  )}
                  onClick={() => input.onChange(option.value)}
                >
                  <Image source={option.image} width="100%" />
                </div>
              )}

              <Form.Radio
                label={option.text}
                name={input.name}
                value={option.value}
                checked={option.value === input.value}
                onChange={(event, data) => input.onChange(data.value)}
                className={css(
                  option.image ? styles.hiddenInput : styles.input
                )}
                disabled={disable.includes(option.value)}
              />
            </div>
          ))}
        </div>

        {hint && (
          <Text size="small" weight="light" className={css(styles.hint)}>
            {hint}
          </Text>
        )}
      </Form.Field>
    )
  }
}

RadioField.contextTypes = {
  theme: PropTypes.object,
}

RadioField.propTypes = {
  direction: PropTypes.oneOf(['horizontal', 'vertical']),
}

const imagePadding = {
  2: 40,
  3: 20,
}

const getStyles = createStyles(
  ({ direction = 'vertical', ...props }, context, theme) => ({
    root: {
      marginTop: 35,
      marginBottom: 35,
    },

    label: {
      color: theme.colors.text,
      display: 'block',
      fontWeight: 'bold',
      marginBottom: 7,
    },

    options: {
      display: 'flex',
      flexDirection: direction === 'horizontal' ? 'row' : 'column',
      justifyContent: 'space-between',
    },

    option: {
      padding: direction === 'horizontal' ? 5 : '5px 0',
      width:
        direction === 'horizontal' ? 100 / props.options.length + '%' : '100%',

      ':first-child': {
        paddingLeft: 0,
      },

      ':last-child': {
        paddingRight: 0,
      },
    },

    image: {
      alignItems: 'center',
      border: '1px solid rgba(0, 0, 0, 0.1)',
      borderRadius: 10,
      cursor: 'pointer',
      display: 'flex',
      height: 80,
      justifyContent: 'center',
      padding: imagePadding[props.options.length] || 40,
      width: '100%',
      opacity: 0.5,
      transition: 'all .2s ease-in',

      ':hover': {
        border: '1px solid rgba(0, 0, 0, 0.2)',
        opacity: 1,
      },
    },

    imageSelected: {
      border: '1px solid ' + theme.colors.primary,
      boxShadow: '0px 5px 20px 0 rgba(0, 0, 0, 0.1)',
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
      opacity: 1,

      ':hover': {
        borderColor: theme.colors.primary,
      },
    },

    hiddenInput: {
      position: 'absolute',
      visibility: 'hidden',
    },

    input: {
      label: {
        background: 'red',

        '&:before': {
          border: '2px solid red',
        },
      },
    },

    hint: {
      marginTop: 7,
    },

    imageDisabled: {
      borderColor: 'rgba(34,36,38,.1)',
      cursor: 'not-allowed',
      opacity: 0.25,

      ':hover': {
        borderColor: 'rgba(34,36,38,.1)',
      },
    },
  })
)



// WEBPACK FOOTER //
// ./src/components/RadioField.js